var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as Enumerable from "linq";
import { autoinject } from "aurelia-framework";
var UserClaimsService = /** @class */ (function () {
    function UserClaimsService() {
    }
    UserClaimsService.prototype.setUserClaims = function (claims) {
        this.claims = claims;
    };
    UserClaimsService.prototype.hasPermission = function (claim) {
        if (this.claims) {
            if (claim) {
                return Enumerable.from(this.claims).any(function (x) { return x.permission === claim; });
            }
        } // TODO: else get and wait for data?
        return false;
    };
    UserClaimsService.prototype.hasPermissions = function (claims) {
        var e_1, _a;
        if (typeof claims == "function") {
            claims = claims();
        }
        if (!claims || claims.length == 0 || (claims && claims.every(function (x) { return !x; })))
            return true;
        try {
            for (var claims_1 = __values(claims), claims_1_1 = claims_1.next(); !claims_1_1.done; claims_1_1 = claims_1.next()) {
                var permission = claims_1_1.value;
                if (this.hasPermission(permission)) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (claims_1_1 && !claims_1_1.done && (_a = claims_1.return)) _a.call(claims_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    UserClaimsService = __decorate([
        autoinject
    ], UserClaimsService);
    return UserClaimsService;
}());
export { UserClaimsService };
